import { type CSSProperties, useMemo } from 'react'
import { clamp } from '@/utils'
import styles from './TOCPluginProgress.module.scss'

type Props = {
  progress: number | null | undefined
}

export const TOCPluginProgress = ({ progress }: Props) => {
  const style = useMemo(
    () =>
      ({
        '--fill': `${clamp(progress ?? 0, 0, 1) * 100}%`,
      }) as CSSProperties,
    [progress],
  )

  return (
    <div className={styles.bar}>
      <div className={styles.fill} style={style} />
    </div>
  )
}
